export default function Home({ totalVisits }) {
    return (
        <>
            <div class='image-full-width'>
                <img src='https://static.secure.website/wstfus/3254/1725723/dawn-nature-sunset-woman-w1920-o.jpg' alt = 'dawn-person'/>
            </div>
            <div class = 'content'>


                <div id = 'split-content'>
                    <div class= 'split-side' id = 'left'>
                        <div class = 'text-box'>
                            <h1>Dear everyone</h1>
                            <p>
                                I really hope our company can be a source of support, love, and care for you. We're here for anyone going through tough times, whether it's related to mental health, disabilities, special needs, or anything else. Our main goal is to provide comfort, safety, trust, and a helping hand.
                            </p>
                            <p>
                                Please don't feel shy about getting in touch; we genuinely want to be there for you. We'll do the legwork to find you the help, love, care, and support you need. 
                            </p>
                        </div>
                    </div>
                    <div class = 'split-side' id = 'right'>
                        <div class = 'button-links'>
                            <a href = 'https://www.skillsyouneed.com/' target = '_blank' rel = 'noreferrer'>
                                Skills You Need
                            </a>
                            <a href = 'https://www.mitoaction.org/' target = '_blank' rel = 'noreferrer'>
                                Information about Mitochondria
                            </a>
                            <a href = 'https://powerfulquotes.yolasite.com/' target = '_blank' rel = 'noreferrer'>
                                Powerful Quotes
                            </a>
                            <a href = 'https://static.secure.website/wscfus/10227331/4025559/support-aand-help-by-qian-lenington-BL.mp4' target = '_blank' rel = 'noreferrer'>
                                Motivational Quotes Video
                            </a>
                        </div>
                    </div>
                </div>

                <div id = 'total-visits'>
                    <p>Total site visits: { totalVisits }</p>
                </div>

                <div class = "divider">
                    <hr />
                    <p>Here are some quick, helpful things if you're going through a hard time</p>
                    <hr />
                </div>

                <div id = 'split-content'>
                    <div class = 'split-side' id = 'left'>
                        <div id = 'coping-skills'>
                            <h2>Some coping skills you may want to try:</h2>
                            <ol>
                                <li>Listen to calming music.</li>
                                <li>Count down 100 to 1.</li>
                                <li>Contact someone you trust.</li>
                                <li>Take a hot or cold bath/shower.</li>
                                <li>Deep breathing.</li>
                                <li>Write (poetry, stories, journal).</li>
                                <li>Play a musical instrument.</li>
                                <li>Sing.</li>
                                <li>Let it out by crying.</li>
                                <li>Take a nap.</li>
                                <li>Play with a pet.</li>
                                <li>Listen to music.</li>
                                <li>Hug a pillow or stuffed animal.</li>
                                <li>Pray.</li>
                                <li>Make a list of blessings in your life.</li>
                                <li>Read the Bible.</li>
                                <li>Ride a bicycle.</li>
                                <li>Yoga.</li>
                                <li>Hug a friend or family member.</li>
                                <li>Call someone you trust.</li>
                                <li>Do something fun.</li>
                                <li>Warp up in a blenket.</li>
                                <li>Watch fun TV Show or Movie or a video.</li>
                                <li>Go outside.</li>
                                <li>Ask for help.</li>
                                <li>Ask a friend to hang out.</li>
                                <li>Ask for a advice.</li>
                            </ol>
                        </div>
                    </div>
                    
                    <div class = 'split-side' id = 'right'>
                        <h1>Good reasons to go to school</h1>

                        <p>
                            Do you have a burning research question or career goal that can be addressed 
                            only by a doctorate in psychology? If so, that's a great reason to sign up 
                            for grad school, says Alan E. Kazdin, PhD, a Yale University psychology 
                            professor and former APA president.
                        </p>
                        <p>
                            "Are you really intrigued by something in psychology, like how the brain 
                            works on solving problems and making seemingly new connections while you are 
                            asleep? Or how exercise, some psychotherapies and some medications alter 
                            depression?" If not, don't go, he advises. "Life is too short and career 
                            options are too many."
                        </p>
                        <p>
                            If you're already invested in a grad program and are questioning whether it 
                            was a good decision, take heart — psychology often allows room to switch 
                            topics and to ask new questions as they evolve, Kazdin says. Kazdin himself 
                            didn't know exactly what he wanted to do when he ventured into a clinical 
                            psychology program, but he did know that he'd have a lot of options. "In my 
                            case, in clinical psychology, one can teach at all sorts of levels, do 
                            research, work in business, at hospitals, engage in clinical work and more. 
                            What career flexibility!"
                        </p>
                        <a href = 'https://www.apa.org/gradpsych/2012/11/right-path' target = '_blank' rel = 'noreferrer'>
                            Original article
                        </a>
                    </div>
                </div>

                <div id = 'split-content'>
                    <div class = 'split-side' id = 'left'>
                                <a href = 'https://www.yourlifeyourvoice.org/Pages/?gad=1&gclid=Cj0KCQjw4vKpBhCZARIsAOKHoWRV8ga9AKQPczYLg9tSignpQ5W43oZmTS2KYrg36rZ7LwVKArp1IycaAoWnEALw_wcB' target = '_blank' rel = 'noreferrer'>
                                    List Of Coping Skills And More
                                </a>
                    </div>
                    <div class = 'split-side' id = 'right'>
                        <h2>The Choice that Challenges Us All</h2>

                        <ol style = {{ textalign: 'start' }}>
                            <li>
                                Slowly do more of what feels right.
                            </li>
                            <li>
                                Shadow someone
                            </li>
                            <li>
                                Create creative overlaps.
                            </li>
                            <li>
                                Find your model
                            </li>
                            <li>
                                Embrace the Grit.
                            </li>
                            <li>
                                Revel in leaving some stones upturned -- for now
                            </li>
                        </ol>
                    </div>
                </div>
                    
            </div>
        </>
    );
}